<template>
	<div>
		<el-card>
			<div slot="header" style="display: inline-block;float: left;font-weight: bolder;font-size: 24px;"></div>

			<div class="jump-btn">
				<el-button type="primary" slot="header" @click="add">{{$t('lang.btn_add')}}</el-button>
				<el-button type="primary" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
			</div>
			<!-- 子门禁表格 -->
			<el-table :data="list" class="wid100" :height="list.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px">
				</el-table-column>
				<el-table-column prop="info" :label="$t('lang.lab_dePointItem')"></el-table-column>
				<el-table-column prop="point" :label="$t('lang.lab_dePoint')"></el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150px">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<el-button class="orange" @click="del(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 添加子门禁dialog -->
		<el-dialog :title="$t('lang.btn_add')" :visible.sync="addDialogFormVisible" :close-on-click-modal="false" center
			top="130px" width="600px">
			<el-form :model="patrolStandardForm" :rules="rules" ref="patrolStandardForm">
				<el-form-item :label="$t('lang.lab_dePointItem')" label-width="120px" prop="info">
					<el-input v-model="patrolStandardForm.info" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_dePoint')" label-width="120px" prop="point">
					<el-input v-model="patrolStandardForm.point" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addDoorDeviceSon(patrolStandardForm)">{{$t('lang.btn_save')}}
				</el-button>
			</div>
		</el-dialog>
		<!-- 修改子门禁dialog -->
		<el-dialog :title="$t('lang.btn_modify')" :visible.sync="editDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="patrolStandardForm" :rules="rules" ref="patrolStandardForm">
				<el-form-item :label="$t('lang.lab_dePointItem')" label-width="120px" prop="info">
					<el-input v-model="patrolStandardForm.info" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_dePoint')" label-width="120px" prop="point">
					<el-input v-model="patrolStandardForm.point" autocomplete="off"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editDoorDeviceSon(patrolStandardForm)">{{$t('lang.btn_save')}}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				patrolStandardId: '',
				list: [],

				addDialogFormVisible: false,
				patrolStandardForm: {
					id: '',
					info: '',
					point: ''
				},

				editDialogFormVisible: false,

				rules: {
					info: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lbl_inspection_name'),
						trigger: 'blur'
					}],
					point: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_dePoint'),
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.patrolStandardId = this.$route.query.id
			this.selectList()
		},
		methods: {
			// 返回
			jump() {
				this.$router.push({
					name: 'InspectionStandardList'
				})
			},
			selectList() {
				let loading = this.$loading()
				this.$get(`patrolStandardPoint/?patrolStandard=` + this.patrolStandardId + `&pageNo=1&pageSize=999`)
					.then(response => {
						// console.log(response);
						this.list = response.list
						loading.close()
					})
					.catch(error => {
						console.log(error)
					})
			},
			add() {
				this.addDialogFormVisible = true
				this.patrolStandardForm.info = ''
				this.patrolStandardForm.point = ''
			},
			addDoorDeviceSon(patrolStandardForm) {
				this.$refs.patrolStandardForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							patrolStandard: this.patrolStandardId,
							info: patrolStandardForm.info,
							point: patrolStandardForm.point
						}
						this.$post(`/patrolStandardPoint`, param)
							.then(response => {
								// console.log(response);
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								loading.close()
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editDialogFormVisible = true
				this.patrolStandardForm.id = row.id
				this.patrolStandardForm.info = row.info
				this.patrolStandardForm.point = row.point
				// console.log(row)
			},
			editDoorDeviceSon(patrolStandardForm) {
				this.$refs.patrolStandardForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							patrolStandard: this.patrolStandardId,
							info: patrolStandardForm.info,
							point: patrolStandardForm.point
						}
						this.$patch(`/patrolStandardPoint/` + this.patrolStandardForm.id, param)
							.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.editDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								this.$message.error(this.$i18n.t('lang.resourEditLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				this.$delete(`/patrolStandardPoint/` + id)
					.then(response => {
						if (response && response.errCode === 0) {
							this.$message({
								type: 'success',
								message: this.$i18n.t('lang.lab_del_success')
							})
							this.selectList()
							loading.close()
						}
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: this.$i18n.t('lang.lab_del_fail')
						})
						loading.close()
						console.log(error)
					})
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>